import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HelpItemState } from 'huddyapi'
import { HelpTooltip } from './helpTooltip.component';

@NgModule({
  declarations: [
    HelpTooltip
  ],
  imports: [
    CommonModule
  ],
  exports: [
    HelpTooltip
  ]
})
export class HelpTooltipModule {}
